export default "__VITE_PUBLIC_ASSET__80fcf979__"